import TimelineIcon from '@mui/icons-material/Timeline';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import Page from 'modules/Page';
import { i18n } from 'i18n';
import * as constants from './constants';

const NotificationsPage = lazyWithSuspense(() => import('./NotificationsPage'));

const page: Page = {
  title: constants.TITLE,
  mainMenuConfig: {
    group: 'Admin',
    iconComponent: TimelineIcon,
  },
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  admin: true,
  component: makePage({ WrappedPage: NotificationsPage, titleFn: () => i18n._(constants.TITLE) }),
};

export default page;
